import classNames from "classnames";
import styles from "./uploadFile.module.css";
import { useEffect, useRef } from "react";

import { Text } from "../text/text";

const getImageText = (n) => {
    if ([11, 12, 13, 14].includes(n % 100)) return `${n} файлов`;
    if (n % 10 === 1) return `${n} файл`;
    if ([2, 3, 4].includes(n % 10)) return `${n} файла`;

    return `${n} файлов`;
}

export const UploadFiles = ({ selectedFiles, setSelectedFiles, ...props }) => {
    const ref = useRef(null);

    useEffect(() => {
        if ((selectedFiles === null || selectedFiles.length === 0) && ref.current) {
            ref.current.value = "";
        }
    }, [selectedFiles]);

    return (
        <label className={classNames(styles.upload_button, { [styles.selected]: !!selectedFiles && selectedFiles.length !== 0 })}>
            <input multiple ref={ref} type="file" className={styles.file_input} onChange={(e) => setSelectedFiles(e.target.files)} {...props} />
            <Text as="div" variant="body" className={styles.input_text} size={14} weight={700} lineHeight="1.1">{selectedFiles && selectedFiles.length !== 0 ? `Выбрано ${getImageText(selectedFiles.length)}` : "Выберите файлы"}</Text>
        </label>
    )
}
